import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/**
 * Redacted per the caller's visibility level — `reason`/`attachments` may be
 * absent. A `404` here means "not found" OR "not activated" OR "visibility
 * None" — all three are indistinguishable over HTTP.
 */
export function useTimeOffRequest(requestId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.request(orgId, requestId),
    queryFn: ({ signal }) => timeOffService.getRequest(requestId, signal),
    staleTime: 30_000,
    enabled: !!orgId && !!requestId,
  });
}
